const estimateStatusMap = {
  converted_to_order: 'converted_to_order',
  not_converted_yet: 'not_converted_yet',
}
export default estimateStatusMap
